import { useQuery } from "@tanstack/react-query";
import { AddressBookEntry } from "../models";
import { queryKeys } from "../queryKeys";
import { axiosInstance } from "../../utils";

export function useAddressBookEntries() {
    const axios = axiosInstance();

    return useQuery({
        ...queryKeys.addressBook.entries,
        queryFn: () => axios.get<AddressBookEntry[]>("api/AddressBook").then(response => response.data),
        meta: {
            errorMessage: "failed to retrieve address book entries",
        },
    });
}
